module.exports = __webpack_public_path__ + "img/tongzhi.d7d12c47.jpg";